import Iframe from 'react-iframe';
import MyModal from '../../Modal';

interface IMyLinkFullModal {
  myLinkFullModalShow: boolean;
  handleCloseMyLinkFullModal: () => void;
  myLinkUrl: string;
}

export default function MyLinkFullModal({
  myLinkFullModalShow,
  handleCloseMyLinkFullModal,
  myLinkUrl,
}: IMyLinkFullModal) {
  return (
    <MyModal
      fullscreen
      size='xl'
      closeButtonLabel="Fechar"
      onClose={() => handleCloseMyLinkFullModal()}
      show={myLinkFullModalShow}
      title="Informar bilhetes manualmente"
      overflow='hidden'
      modalBody={(
        // <iframe
        //   src={myLinkUrl}
        //   width="100%"
        //   title="Informar bilhetes manualmente"
        // />

        <Iframe
          url={myLinkUrl}
          width="100%"
          height={`${window.innerHeight}px`}
          position="relative"
          styles={{
            bottom: '130px',
            overflow: 'hidden',
          }}
        />
      )}
    />
  );
}
